import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import CronHealthView from './CronHealthView';

const route: FuseRouteItemType = {
	path: 'health/cron',
	element: <CronHealthView />
};

export default route;
